<template>
  <div class="page-box">
    <!-- 头部组件 -->
    <ProductHeader :currentTab="0" stepTitle="票型及价格"></ProductHeader>
    <div class="page-main">
      <!-- 发布助手 -->
      <PublishHelper></PublishHelper>
      <div class="main-content">
        <a-card :bordered="false" :headStyle="{borderBottom:'0px'}" :bodyStyle="{paddingTop:'0px'}">
          <a-row slot="title">
            <a-col :span="8">
              <span class="card-title">基础信息</span>
            </a-col>
          </a-row>
          <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" :label-col="currentFormLayout.labelCol"
                        :wrapper-col="currentFormLayout.wrapperCol"
          >
            <a-form-model-item label="商品标题" prop="proName">
              <a-input v-model="ruleForm.proName" :maxLength="120" placeholder="请输入景点名称">
                <span slot="addonAfter">{{ ruleForm.proName.length }}/120</span>
              </a-input>
            </a-form-model-item>
            <a-form-model-item label="景区" prop="scenicSpot">
              <a-input v-model="ruleForm.scenicSpot" :maxLength="35" placeholder="请输入景区">
                <span slot="addonAfter">{{ ruleForm.scenicSpot.length }}/35</span>
              </a-input>
            </a-form-model-item>
            <a-form-model-item label="介绍标语" prop="title">
              <a-textarea v-model="ruleForm.title" :maxLength="100" placeholder="请输入"
                          :auto-size="{ minRows: 3, maxRows: 5 }"/>
            </a-form-model-item>
            <a-form-model-item
              label="景点区域"
              prop="areaList"
            >
              <AreaSelected
                v-model="ruleForm.areaList"
                :areaStyle="{'width':'400px'}"
                area-type="all"
                :changeOnSelect="false"
                @change="onCityChange"
              ></AreaSelected>
              <!--              <AreaKinkage-->
              <!--                v-model="ruleForm.areaList"-->
              <!--                ref="areaData"-->
              <!--                @getAreaData="getAreaData"></AreaKinkage>-->
            </a-form-model-item>
            <a-form-model-item label="详细地址" prop="address">
              <a-input v-model="ruleForm.address" @blur="getLongitude(false)" placeholder="请输入详细地址">
              </a-input>
            </a-form-model-item>
            <a-form-model-item label="经纬度" style="margin-bottom:0;">
              <a-row :gutter="20">
                <a-col :span="8">
                  <a-form-model-item prop="longitude">
                    <a-input v-model="ruleForm.longitude" :maxLength="80" placeholder="请选择经度"
                             :disabled="true"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item prop="latitude">
                    <a-input v-model="ruleForm.latitude" :maxLength="80" placeholder="请选择纬度"
                             :disabled="true"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-button @click="showMapEvent">选择</a-button>
                </a-col>
              </a-row>
            </a-form-model-item>
            <a-form-model-item label="景点主题">
              <a-cascader
                :fieldNames="{ label: 'label', value: 'value', children: 'children' }"
                :options="ticketList"
                @change="(value, selectedOptions) => ticketThemeLevelIdChange(value, selectedOptions)"
                style="width: 420px"
                placeholder="请选择"></a-cascader>
              <a-button style="margin-left: 20px" @click="addThemeLevel">添加</a-button>
              <div class="tThemeLevelMain">
                <div v-for="(i,idx) in ticketThemeLevelArr" :key="idx" class="tThemeLevelBtn">
                  {{ i.ticketThemeThemeId ? i.ticketThemeThemeName : i.ticketThemeFirstLevelName }}
                  <a-icon @click="deleteThemeLevel(i,idx)" type="close-circle"/>
                </div>
              </div>
            </a-form-model-item>
            <a-form-model-item label="交通信息">
              <a-textarea
                v-model="ruleForm.traffic"
                :rows="3"
                :maxLength="500"
                placeholder="请输入交通信息"
                style="width: 100%"
              ></a-textarea>
            </a-form-model-item>
            <a-form-model-item
              label="营业时间"
            >
              <a-time-picker
                v-model="ruleForm.openStartTime"
                format="HH:mm"/>
              至
              <a-time-picker
                v-model="ruleForm.openEndTime"
                format="HH:mm"/>
            </a-form-model-item>
            <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
              <a-input
                v-model="ruleForm.openDes"
                placeholder="其他补充"
              />
            </a-form-model-item>
            <a-form-model-item label="景点介绍" required>
              <p style="color: red">如果上传本地图片，图片大小应小于1M，图片格式为.jpg .png</p>
              <CustomUeditor v-model="ruleForm.proDes"></CustomUeditor>
            </a-form-model-item>
            <a-form-model-item label="商品轮播图" prop="imgs">
              <custom-upload-pro-images v-model="ruleForm.imgs"
                                        :pro-id="proId" :multiple-selected="true"
                                        :draggableUpdate="true">
              </custom-upload-pro-images>
            </a-form-model-item>
            <a-form-model-item label="免票政策">
              <a-textarea
                v-model="ruleForm.freePolicy"
                :rows="3"
                :maxLength="500"
                placeholder="请输入免票政策"
                style="width: 100%"
              ></a-textarea>
            </a-form-model-item>
            <a-form-model-item label="优惠政策">
              <a-textarea
                v-model="ruleForm.cheapInfo"
                :rows="3"
                :maxLength="500"
                placeholder="请输入优惠政策"
                style="width: 100%"
              ></a-textarea>
            </a-form-model-item>
            <a-form-model-item label="重要须知">
              <a-textarea
                v-model="ruleForm.importantInfo"
                :rows="3"
                :maxLength="500"
                placeholder="请输入重要须知"
                style="width: 100%"
              ></a-textarea>
            </a-form-model-item>
            <a-form-model-item label="发票说明">
              <a-textarea
                v-model="ruleForm.invoiceShows"
                :rows="3"
                :maxLength="500"
                placeholder="请输入发票说明"
                style="width: 100%"
              ></a-textarea>
            </a-form-model-item>
            <a-form-model-item label="发票模板" prop="invoiceTemplateId">
              <InvoiceSelect ref="InvoiceSelect" :proId="proId" :catalogId="catalogId"
                             v-model="ruleForm.invoiceTemplateId"></InvoiceSelect>
            </a-form-model-item>

            <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
              <a-button type="primary" :disabled="proSource!=0" @click="onSubmit" :loading="submitLoading">
                提交并下一步
              </a-button>
              <!-- <a-button  @click="backEvent" style="margin-left: 10px">保存草稿</a-button> -->
            </a-form-model-item>
          </a-form-model>
        </a-card>

      </div>
    </div>

    <!-- 天地图 -->
    <MapLocationPicker
      :visible.sync="showMap"
      :default-lat="ruleForm.proLatitude"
      :defaultLng="ruleForm.proLongitude"
      @confirm="mapConfirmEvent"
    ></MapLocationPicker>
  </div>
</template>

<script>
import ProductHeader from '../components/ProductHeader'
import PublishHelper from '../components/PublishHelper'
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'
import AreaKinkage from '@/customComponents/AreaKinkage/AreaKinkage'
import CustomUploadProImages from '@/customComponents/CustomUploadProImages/CustomUploadProImages'
import CustomUeditor from '@/customComponents/CustomUeditor/CustomUeditor'
import InvoiceSelect from '../components/InvoiceSelect'
import AreaSelected from '@/customComponents/AreaSelected/AreaSelected'
import MapLocationPicker from '@/customComponents/MapLocationPicker/index.vue'
import { getLatAndLng, parserAddress } from '@/utils/helper/TianDiTuHelper'

export default {
  name: 'TicketsBasicInfo',
  components: {
    MapLocationPicker,
    ProductHeader,
    PublishHelper,
    AreaKinkage,
    CustomUploadProImages,
    CustomUeditor,
    InvoiceSelect,
    AreaSelected
  },
  mixins: [ruleFormMixins],
  data() {
    return {
      proSource: this.$route.query.proSource, //判断自有产品还是非自有产品
      proId: this.$route.query.proId, //产品ID
      catalogId: this.$route.query.catalogId,
      submitLoading: false,
      submitFormData: '',
      ruleForm: {
        proId: this.$route.query.proId,
        proName: '',
        scenicSpot: '',
        title: '',
        areaList: [],
        imgs: [],
        address: '',
        longitude: undefined,
        latitude: undefined,
        proDes: '',
        traffic: '',
        openEndTime: undefined,
        openStartTime: undefined,
        openDes: '',
        freePolicy: '',
        cheapInfo: '',
        importantInfo: '',
        invoiceShows: '',
        invoiceTemplateId: undefined,//发票
        cityName: '',
        countyName: '',
        provinceName: '',
        themeList: []
      },
      rules: {
        proName: [
          { required: true, message: '请输入景点名称', trigger: 'blur' }
        ],
        scenicSpot: [
          { required: true, message: '请输入景区', trigger: 'blur' }
        ],
        title: [
          { required: true, message: '请输入介绍标语', trigger: 'blur' }
        ],
        areaList: [
          { required: true, message: '请选择景点区域', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ],
        longitude: [
          {
            pattern: /^(\-|\+)?(((\d|[1-9]\d|1[0-7]\d|0{1,3})\.\d{0,20})|(\d|[1-9]\d|1[0-7]\d|0{1,3})|180\.0{0,20}|180)$/,
            message: '经度整数部分为0-180,小数部分最长20位',
            trigger: 'blur'
          }
        ],
        latitude: [
          {
            pattern: /^(\-|\+)?([0-8]?\d{1}\.\d{0,20}|90\.0{0,20}|[0-8]?\d{1}|90)$/,
            message: '纬度整数部分为0-90,小数部分最长20位',
            trigger: 'blur'
          }
        ],
        imgs: [
          { required: true, message: '请选择图片', trigger: ['blur', 'change'] }
        ],
        invoiceTemplateId: [
          { required: true, message: '请选择发票模板', trigger: ['blur', 'change'] }
        ]
      },
      areaOptions: [],
      showMap: false,
      ticketList: [],//景点主题
      ticketThemeLevelSingle: {},
      ticketThemeLevelArr: [],
      imageList: [],
      fileList: [],
      selectedOptions: []
    }
  },
  created() {
    this.getTicketInfo()
    this.getTicketInfoList()
  },
  mounted() {

  },
  methods: {
    onCityChange(item) {
      this.ruleForm.areaList = item.value
      if (item.value && item.value.length > 0) {
        if (item.value[0] == 0) {
          this.ruleForm.countryId = ''
          this.ruleForm.countryName = ''
          this.ruleForm.cityId = null
          this.ruleForm.cityName = null

          this.ruleForm.provinceId = item.value[1]
          this.ruleForm.cityId = item.value[2]
          this.ruleForm.countyId = item.value[3]
        } else {
          this.ruleForm.provinceId = null
          this.ruleForm.cityId = null
          this.ruleForm.countyId = null

          this.ruleForm.countryId = item.value[1]
          this.ruleForm.countryName = item.selectedOptions[1].label
          this.ruleForm.cityId = item.value[2]
          this.ruleForm.cityName = item.selectedOptions[2].label
        }
      }
      this.selectedOptions = item.selectedOptions ? item.selectedOptions : []
    },
    getAreaData(data) {
      this.ruleForm.areaList = data
      if (data && data.length > 0) {
        this.ruleForm.provinceId = data[0]
        this.ruleForm.cityId = data[1]
        this.ruleForm.countyId = data[2]
      }
    },
    showMapEvent() {
      this.showMap = true
    },
    mapConfirmEvent(location) {
      this.showMap = false
      this.ruleForm.longitude = location.lng
      this.ruleForm.latitude = location.lat
    },
    cancelShowMap() {
      this.showMap = false
    },
    // 景点门票信息联动
    getTicketInfoList() {
      this.getHttpServices().getProService().get('ticket/getTicketThemeParam').then(res => {
        this.ticketList = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    ticketThemeLevelIdChange(val, selectedOptions) {
      if (selectedOptions) {
        let obj = {
          ticketThemeFirstLevelName: selectedOptions[0].label,
          ticketThemeFirstLevelId: selectedOptions[0].value,
          ticketThemeThemeName: selectedOptions[1] ? selectedOptions[1].label : '',
          ticketThemeThemeId: selectedOptions[1] ? selectedOptions[1].value : 0
        }
        this.ticketThemeLevelSingle = obj
      } else {
        this.ticketThemeLevelSingle = {}
      }
    },
    addThemeLevel() {
      if (this.ticketThemeLevelSingle && !this.ticketThemeLevelSingle.ticketThemeFirstLevelId) {
        this.$message.error('请选择景点主题')
        return
      }
      if (this.ticketThemeLevelArr.length > 19) {
        this.$message.error('景点主题不能超过20个')
        return
      }
      let flag = false
      if (this.ticketThemeLevelArr.length > 0) {
        this.ticketThemeLevelArr.forEach((v, k) => {
          if (v.ticketThemeThemeId) {
            if (v.ticketThemeFirstLevelId === this.ticketThemeLevelSingle.ticketThemeFirstLevelId && v.ticketThemeThemeId === this.ticketThemeLevelSingle.ticketThemeThemeId) {
              flag = true
            }
          } else {
            if (v.ticketThemeFirstLevelId === this.ticketThemeLevelSingle.ticketThemeFirstLevelId) {
              flag = true
            }
          }
        })
      }
      if (flag) {
        this.$message.error('请不要重复选择景点主题')
        return
      }
      this.ticketThemeLevelArr.push(this.ticketThemeLevelSingle)
    },
    deleteThemeLevel(i, idx) {
      if (this.ticketThemeLevelArr.length > 0) {
        this.ticketThemeLevelArr.splice(idx, 1)
      }
    },
    getLongitude(flag) {
      if (this.ruleForm.areaList.length > 0) {
        this.getBaiDuLatAndLng().then(res => {
          this.ruleForm.longitude = res.lng//经度
          this.ruleForm.latitude = res.lat//纬度
        }).catch(err => this.showNetWorkErrorMessage(err)).finally(() => {
          if (flag) {
            this.submitData()
          }
        })
      }
    },
    //获取经纬度
    getBaiDuLatAndLng() {
      return new Promise((resolve, reject) => {
        // let parms = {
        //   address:this.ruleForm.address,
        //   cityId: this.ruleForm.cityId?this.ruleForm.cityId:0,
        //   countyId:this.ruleForm.countyId?this.ruleForm.countyId:0,
        //   provinceId:this.ruleForm.provinceId?this.ruleForm.provinceId:0
        // }
        // this.getHttpServices().getProService().post("public/getBaiDuLatAndLng",parms)
        const realAddress = parserAddress(this.selectedOptions, this.ruleForm.address)
        getLatAndLng(this, realAddress).then(res => {
          this.getLogUtils().logWithTag('getBaiDuLatAndLng', res)
          resolve(res)
        }).catch(reason => {
          reject(reason)
          this.showNetWorkErrorMessage(reason)
        })
      })
    },
    //获取门票基本信息
    getTicketInfo() {
      if (this.proId != 0) {
        this.getHttpServices().getProService().get('ticket/getTicketByProId/' + this.proId).then(res => {
          this.getLogUtils().logWithTag('getTicketInfo', res)
          this.ticketThemeLevelArr = res.themeList ? res.themeList : []
          let openStartTime = res.openEndTime ? this.getDateHelper().getTimeMinute(res.openStartTime) : undefined
          let openEndTime = res.openEndTime ? this.getDateHelper().getTimeMinute(res.openEndTime) : undefined
          this.ruleForm = {
            ...res,
            openStartTime: openStartTime,
            openEndTime: openEndTime,
            imgs: res.imgs && res.imgs != '' ? res.imgs.split(',') : []
          }
          if (res.provinceId && res.cityId && res.countyId) {
            this.ruleForm.areaList = [0, res.provinceId, res.cityId, res.countyId]
          }
          if (res.countryId && res.cityId) {
            this.ruleForm.areaList = [1, res.countryId, res.cityId]
          }
          // this.$refs.areaData.getArea(this.ruleForm.areaList)
          this.$refs.InvoiceSelect.getMatchTemplateId()
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      }
    },
    checkForm() {
      if (!this.ruleForm.proDes) {
        this.$message.error('请输入景点介绍')
        return false
      }
      return true
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid && this.checkForm()) {
          if (this.ruleForm.areaList[0] == 0) {
            this.getLongitude(true)
          } else {
            this.submitData()
          }
        } else {
          return false
        }
      })
    },
    setData(data) {
      let hour = new Date(data).getHours()
      let minute = new Date(data).getMinutes()
      if (Number(hour) < 10) {
        hour = '0' + hour
      }
      if (Number(minute) < 10) {
        minute = '0' + minute
      }
      return hour + ':' + minute
    },
    // 保存接口
    submitData() {
      this.submitLoading = true
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      this.submitFormData.imgs = this.submitFormData.imgs.length > 0 ? this.submitFormData.imgs.join(',') : ''
      this.submitFormData.openStartTime = this.submitFormData.openStartTime ? this.setData(this.submitFormData.openStartTime) : ''
      this.submitFormData.openEndTime = this.submitFormData.openEndTime ? this.setData(this.submitFormData.openEndTime) : ''
      this.submitFormData.themeList = this.ticketThemeLevelArr
      delete this.submitFormData.areaList
      this.getHttpServices().getProService().post('ticket/saveTicket', this.submitFormData).then(res => {
        this.$message.success('门票基本信息保存成功')
        this.ruleForm.proId = res
        this.$router.push({
          name: 'OptionList',
          query: {
            proId: this.ruleForm.proId,
            catalogId: this.catalogId,
            proSource: this.proSource,
            isBack: this.proId == 0 ? 1 : undefined
          }
        })
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    }
  }

}
</script>
<style lang="less" scoped>
.page-box {
  .page-main {
    margin: 10px;
    display: flex;

    .main-content {
      margin-left: 10px;
      width: 400px;
      flex-grow: 1;
    }
  }
}

.pt10 {
  padding-top: 10px;
}

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}

.tThemeLevelMain {
  .tThemeLevelBtn {
    display: inline-block;
    margin-right: 15px;
    padding: 0 10px;
    border: 1px #ccc solid;
    border-radius: 5px;
    line-height: 28px;
    font-size: 12px;
    cursor: pointer;
  }

  .tThemeLevelBtn:hover {
    border: 1px #FAAD14 solid;
  }
}
</style>